import { UKOnly } from '@iwIntlProvider/CountryWrappers';
import { Text } from '@iwoca/orion-ui';
import { RootState } from '@iwProvider/configureStore';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import messages from './ManualPaymentModal.messages';
import styles from './ManualPaymentModal.module.css';
import { FormattedCurrency } from '../../../iwIntlProvider/FormattedCurrency';
import { CLOSE_MODAL } from '../../../iwModals/Modals.actions';
import DashboardLink from '../../navigation/DashboardLink';
import { Prompt } from '../../ui/prompt';

const mapStateToProps = ({ manualPaymentModal }: RootState) =>
    manualPaymentModal;

const mapDispatchToProps = (dispatch: Dispatch) => ({
    cancel: () => dispatch({ type: CLOSE_MODAL })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const ManualPaymentModal = ({
    amount,
    iban,
    accountNumber,
    sortCode,
    name,
    reference,
    cancel
}: PropsFromRedux) => {
    const formattedManualPaymentAmount = <FormattedCurrency value={amount} />;

    return (
        <div className={styles.BankTransferModal}>
            <div className={styles.title}>
                <FormattedMessage {...messages.title} />
            </div>

            <div className={styles.subTitle}>
                <FormattedMessage
                    {...messages.subTitle}
                    values={{
                        amount: formattedManualPaymentAmount
                    }}
                />
            </div>

            <div className={styles.warningMessage}>
                <FormattedMessage {...messages.warningMessage} />
            </div>

            <div className={styles.content}>
                <table>
                    <tbody>
                        {iban ? (
                            <>
                                <tr>
                                    <td>
                                        <FormattedMessage {...messages.iban} />
                                    </td>
                                    <td>{iban}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            {...messages.referenceName}
                                        />
                                    </td>
                                    <td>{reference}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            id="_.your_company.repayment_card.payee"
                                            defaultMessage="Payee"
                                        />
                                    </td>
                                    <td>{name}</td>
                                </tr>
                            </>
                        ) : (
                            <>
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            {...messages.accountNumber}
                                        />
                                    </td>
                                    <td>{accountNumber}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            {...messages.sortCode}
                                        />
                                    </td>
                                    <td>{sortCode}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            {...messages.referenceName}
                                        />
                                    </td>
                                    <td>{name}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            {...messages.referenceID}
                                        />
                                    </td>
                                    <td>{reference}</td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
                <UKOnly>
                    <Text className="mt-s text-s font-bold">
                        <FormattedMessage {...messages.chapsRepayments} />
                    </Text>
                </UKOnly>
            </div>

            <Prompt className={styles.prompt}>
                <button onClick={cancel}>
                    <FormattedMessage {...messages.cancel} />
                </button>

                <DashboardLink>
                    <FormattedMessage {...messages.sentMoney} />
                </DashboardLink>
            </Prompt>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(ManualPaymentModal);
